module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/users-f665b3ee5dc4077f3b4cdd70c65a9075.svg";